export var EmploymentStatusCode;
(function (EmploymentStatusCode) {
    EmploymentStatusCode["A"] = "A";
    EmploymentStatusCode["F"] = "F";
    EmploymentStatusCode["I"] = "I";
    EmploymentStatusCode["IF"] = "IF";
    EmploymentStatusCode["L"] = "L";
    EmploymentStatusCode["Q"] = "Q";
    EmploymentStatusCode["R"] = "R";
    EmploymentStatusCode["S"] = "S";
    EmploymentStatusCode["T"] = "T";
    EmploymentStatusCode["V"] = "V";
    EmploymentStatusCode["W"] = "W";
    EmploymentStatusCode["X"] = "X";
})(EmploymentStatusCode || (EmploymentStatusCode = {}));
export const EMPLOYMENT_STATUSES_ALLOWED_CODES = [
    EmploymentStatusCode.A,
    EmploymentStatusCode.F,
    EmploymentStatusCode.I,
    EmploymentStatusCode.IF,
    EmploymentStatusCode.L,
    EmploymentStatusCode.Q,
    EmploymentStatusCode.R,
    EmploymentStatusCode.S,
    EmploymentStatusCode.T,
    EmploymentStatusCode.V,
    EmploymentStatusCode.W,
    EmploymentStatusCode.X,
];
export const PAY_FREQUENCY_TYPE = {
    Annually: 'Annually',
    Weekly: 'Weekly',
    Bi_Weekly: 'Bi_Weekly',
    Daily: 'Daily',
    Monthly: 'Monthly',
    Semi_Monthly: 'Semi_Monthly',
    Quarterly: 'Quarterly',
};
export const RATE_OF_PAY_TYPE_MAP = {
    A: 'Annually',
    W: 'Weekly',
    B: 'Biweekly',
    D: 'Daily',
    H: 'Hourly',
    M: 'Monthly',
    S: 'Semi_Monthly',
};
export const PAY_FREQUENCY_TYPE_MAP = {
    1: PAY_FREQUENCY_TYPE.Weekly,
    2: PAY_FREQUENCY_TYPE.Bi_Weekly,
    3: PAY_FREQUENCY_TYPE.Semi_Monthly,
    4: PAY_FREQUENCY_TYPE.Monthly,
    5: PAY_FREQUENCY_TYPE.Quarterly,
    6: PAY_FREQUENCY_TYPE.Daily,
    7: PAY_FREQUENCY_TYPE.Annually,
};
export const PAY_FREQUENCY_TYPE_LABEL_MAP = {
    [PAY_FREQUENCY_TYPE.Weekly]: 'Weekly',
    [PAY_FREQUENCY_TYPE.Bi_Weekly]: 'Bi-Weekly',
    [PAY_FREQUENCY_TYPE.Semi_Monthly]: 'Semi-Monthly',
    [PAY_FREQUENCY_TYPE.Monthly]: 'Monthly',
    [PAY_FREQUENCY_TYPE.Quarterly]: 'Quarterly',
    [PAY_FREQUENCY_TYPE.Daily]: 'Daily',
    [PAY_FREQUENCY_TYPE.Annually]: 'Annually',
};
export const EMPLOYMENT_TYPE_MAP = {
    C: 'Casual/On-Call',
    F: 'Full-time',
    P: 'Part-time',
    S: 'Seasonal',
    T: 'Temporary',
};
//# sourceMappingURL=position.js.map